import { GenericStyleModel } from '../../../Common/Styles/models/generic-style.model';
import { ChartDisplaySettingsModel } from './chart-display-settings.model';

export class ChartStylesModel extends GenericStyleModel {
    colorMap: { [key: string]: string };
    chartDisplaySettings: ChartDisplaySettingsModel;

    constructor(apiModel?: any) {
        super(apiModel);

        if (apiModel?.colorMap) {
            // the spread operator here is actually relevant,
            // it does a shallow clone of the object which we need to happen sometimes so change detection notices a style change
            this.colorMap = {
                ...apiModel.colorMap
            };
        } else if (!this.colorMap) {
            this.colorMap = {};
        }

        if (apiModel?.chartHeaderSettings) {
            this.chartDisplaySettings = new ChartDisplaySettingsModel(apiModel.chartHeaderSettings);
        } else if (!this.chartDisplaySettings) {
            this.chartDisplaySettings = new ChartDisplaySettingsModel();
        } else if (this.chartDisplaySettings) {
            this.chartDisplaySettings = new ChartDisplaySettingsModel(this.chartDisplaySettings);
        }
    }

    equals(other: ChartStylesModel, compareTemplate: boolean): boolean {
        if (!super.equals(other, compareTemplate)) {
            return false;
        }

        if (JSON.stringify(this.colorMap) !== JSON.stringify(other.colorMap)) {
            return false;
        }

        if (!this.chartDisplaySettings.isEqual(other.chartDisplaySettings)) {
            return false;
        }

        return true;
    };

    clone(): ChartStylesModel {
        return new ChartStylesModel(this.toApi());
    }
};
